<template>
  <div>
    <div>
      <div class="columns is-vcentered is-mobile is-gapless" style="margin-bottom: 10px;">
        <div class="column is-narrow" style="margin-right: 10px;">
          <i class="fas fa-info"></i>
        </div>
        <div class="column">
          <span><h3 class="title is-6">Informasi {{ group.type == 'ACADEMIC' ? 'Kelas Akademik' : 'Kelas Umum' }}</h3></span>
        </div>
        <div class="column is-narrow is-hidden-tablet">
          <a
            class=""
            @click="open = !open"
            aria-controls="contentIdForA11y1"
          >
            <i class="fas fa-caret-up" v-if="open"></i>
            <i class="fas fa-caret-down" v-else></i>
          </a>
        </div>
      </div>

      <b-collapse v-if="open" :open="open" aria-id="contentIdForA11y1" class="box is-boxed-3">
        <div class="columns is-centered">
          <div class="column is-narrow">
            <shorticon :shortName="group.shortName" size="large" :bgColor="group.color"></shorticon>
          </div>
          <!-- <img v-if="!isEmpty(group.media) && !isEmpty(group.media.images)" :src="group.media.images.thumb.link">
          <img v-else src="/assets/img/no-img.png"> -->
        </div>

        <div class="has-text-centered columns">
          <div class="column">
            <h3 class="font-16 has-text-darkblue font-w-600">{{ group.name }}</h3>
            <span class="has-text-grey font-14">{{ group.description }}</span>
          </div>
        </div>
        <div class="">
          <div class="box is-boxed-3" style="margin-bottom: 10px;">
            <p class="title font-16 font-w-600" style="margin-bottom: 10px;">{{ group.type == 'ACADEMIC' ? 'Dosen Pengajar' : 'Pengelola' }}</p>
            <ul>
              <li v-for="(teacher, $key) in teachers" :key="$key">
                <p class="has-text-dark font-14">
                  <i class="fas fa-user-graduate"></i>&nbsp;
                  <nuxt-link v-if="!isEmpty(teacher.user) && !isEmpty(teacher.user.email)" class="has-text-darkblue" :to="{name: 'profile-username', params: {username: teacher.user.email}}">{{ detailMember(teacher, 'name') }}</nuxt-link>
                  <span v-if="isEmpty(teacher.user) || (!isEmpty(teacher.user) && isEmpty(teacher.user.email))" class="has-text-dark">{{ detailMember(teacher, 'name') }}</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="box is-boxed-3" style="margin-bottom: 10px;" v-if="group.type == 'ACADEMIC'">
            <p class="title font-16 font-w-600" style="margin-bottom: 10px;">Periode Akademik</p>
            <p class="font-14">{{ group.periodLabel }}</p>
          </div>
          <div class="box is-boxed-3" style="margin-bottom: 10px;" v-if="group.type == 'ACADEMIC' && !isEmpty(group.className)">
            <p class="title font-16 font-w-600" style="margin-bottom: 10px;">Nama Kelas</p>
            <p class="font-14">{{ group.className }}</p>
          </div>
        </div>
        <div v-if="group.type !== 'ACADEMIC' && group.memberRole == 'M' && group.id != 217">
          <div class="text-center" style="margin-top:20px;">
            <a href="" @click.prevent="leave(group.id)" class="button is-danger is-fullwidth tooltip" data-tooltip="Keluar Grup">
              Keluar Grup
            </a>
          </div>
        </div>
      </b-collapse>
    </div>

    <br>
  </div>
</template>

<script>
import { GROUP } from '~/consts';
import CLASSMATE_MIXINS from '~/mixins/classmate'

export default {
  mixins: [CLASSMATE_MIXINS],

  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    group: {
      type: Object,
      required: true
    },
    getGroup: {
      type: Function,
      required: true
    }
  },

  computed: {
    teachers() {
      return this.group.groupAdmins;
    },
  },

  data() {
    return {
      open: this.isOpen,
      loading_join_group: false
    }
  },

  methods: {
    detailMember(member, attribute) {
      const user = member.user;

      if (this.group.type === 'ACADEMIC') {
        return member.account[attribute];
      }

      if (attribute == 'type') {
        return member.role == 'O' || member.role == 'A' ? 'L' : 'S';
      } else {
        return member.user[attribute];
      }
    },
    onGroupLeftedSuccess() {
      this.$router.push({path: '/panel/groups'})
    },
    onJoinSuccess() {
      this.getGroup();
    }
  }
}
</script>
